import { http } from '@/api/client/httpClient';
import type { Select2Option } from '@/components/forms/Select2';
import type { ExecutionQualityFilterDto, ExecutionQualityResultDto } from '@/api/types/lpAccounts';

const BASE = '/api/app/execution-quality';

export const executionQualityApi = {
  async getSlippageData(filter: ExecutionQualityFilterDto): Promise<ExecutionQualityResultDto> {
    const { data } = await http.get<ExecutionQualityResultDto>(`${BASE}/slippage-data`, { params: filter });
    return data;
  },
  async getConnectors(): Promise<Select2Option[]> {
    const { data } = await http.get<{ value: number; text: string }[]>(`${BASE}/connectors`);
    return (data ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
};
